query MobileSdkTests(
	$offset: Int!
	$limit: Int!
	$sort: msdk_test_runsSort
	$textSearch: msdk_test_runsSearchInsensitive
	$textSearchExact: msdk_test_runsSearchInsensitive
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$criticalIssuesFilter: ConditionInt
) {
	msdk_test_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $osFilter
		app_eq: $appFilter
		app_version_eq: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq: $sdkVersionFilter
		critical_issues_gt: $criticalIssuesFilter
	) {
		run_id
		test_name
		total_scans
		total_issues
		critical_issues
		run_time
		custom_fields
		app
		app_version
		os
		sdk_type
		product_version
	}
	total: msdk_test_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $osFilter
		app_eq: $appFilter
		app_version_eq: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq: $sdkVersionFilter
		critical_issues_gt: $criticalIssuesFilter
	) {
		run_id_count
	}
	unfiltered_total: msdk_test_runs {
		run_id_count
	}
}

query RecentMobileSdkTests(
	$offset: Int!
	$limit: Int!
	$sort: msdk_test_runs_latestSort
	$textSearch: msdk_test_runs_latestSearchInsensitive
	$textSearchExact: msdk_test_runs_latestSearchInsensitive
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$criticalIssuesFilter: ConditionInt
) {
	msdk_test_runs: msdk_test_runs_latest(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $osFilter
		app_eq: $appFilter
		app_version_eq: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq: $sdkVersionFilter
		critical_issues_gt: $criticalIssuesFilter
	) {
		run_id
		test_name
		total_scans
		total_issues
		critical_issues
		run_time
		custom_fields
		app
		app_version
		os
		sdk_type
		product_version
	}
	total: msdk_test_runs_latest(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $osFilter
		app_eq: $appFilter
		app_version_eq: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq: $sdkVersionFilter
		critical_issues_gt: $criticalIssuesFilter
	) {
		run_id_count
	}
	unfiltered_total: msdk_test_runs {
		run_id_count
	}
}
